/* Panier HOVER : tiroir <cart-drawer> + page /cart.
   - Ouvre le tiroir après tout ajout au panier (formulaires Dawn, ajouts rapides, Kaching Bundles, offre et coffrets des fiches…).
   - Paliers de cadeaux (HPN.paliers, source : snippets/hover-cart-paliers.liquid ; seuils en centimes d'euro, ×1,1×taux hors euro),
     comptés sur tout le panier payé (après réductions, sans cadeaux ni exclus : concepts physiques, app, formules…),
     à condition d'avoir au moins un produit physique (panier 100 % digital = aucun cadeau physique) :
       pochon dès 1 produit physique, livraison offerte + 1 formule offerte + mini-stickers dès 40 €, 16 stickers Douaa dès 60 €
     (mini-stickers passés de 20 à 40 € le 22/10/2026, décision de Wyssem). Gratuité : fonction « Cadeaux Qalbeen », plus de codes cachés.
     Chaque cadeau (HPN.gifts) a son seuil « min » ; il n'est ajouté qu'à partir de ce seuil :
       mode « kaching » : ligne avec la propriété _kaching_cart (promoHash du palier Kaching qui contient ce produit, kusd)
                          + attribut _kaching_cart_attributes (total physique) : la réduction Kaching Cart (KCART) l'offre
                          (il faut aussi que le total atteigne le palier Kaching, kusd $) ;
       mode « code »    : ligne _hv_cadeau = cadeau + code caché « cadeau ».
   - 30 jours d'app : dès un produit physique ou une formule thérapie (26/10/2026, demande de Wyssem) ; ligne _hv_cadeau = app30 + code caché de l'app. Ajoutée par la cliente,
     ou d'office si HPN.app.pre (réglage « cochée d'avance ») ; une fois retirée par la cliente, elle n'est plus rajoutée.
     Jamais si l'app est achetée dans le même panier (au mois ou à l'année, ex. l'offre « à l'année » de la fiche).
   - Formule offerte (palier marqué « formule ») : ajoutée d'office dès le palier (formuleParDefaut, 26/10/2026), la cliente la change
     dans la fenêtre des formules (assets/hover-offre-formules.js),
     ligne _hv_cadeau = formule40 + code caché HPN.codeF40 ; retirée si le panier repasse sous le palier.
     Le code « acheter X, obtenir Y » ne compte QUE les produits des collections du réglage hv_cart_f40_collections
     (tous-nos-concepts + app-qalbeen : HPN.f40h) : la formule offerte est débloquée sur ce montant-là (f40Base), pas sur tout le panier.
   - Formules thérapie offertes avec Qalbeen+ à l'année (offre des fiches : _hv_offre = formule-an ; page de l'app : _hv_offre =
     app-an-2-formules) : code caché HPN.codeAn, gardé tant que l'app 1 an est dans le panier ; app 1 an retirée = ces formules
     retirées aussi ; 2 au plus ; une de ces formules qui n'est pas à 0 € est retirée (garde-fou).
   - Garde-fou : un cadeau (ou l'app, ou la formule) qui n'est pas réellement à 0 € dans /cart.js est retiré : ce qui est affiché = ce qui est payé.
   - Même calcul pour la jauge du panier, la barre fine sous l'en-tête ([data-hpn-strip]) et l'échelle de l'accueil ([data-hpn-ladder]).
   Tout passe par une file : une seule opération sur le panier à la fois. */
(function () {
  'use strict';
  var C = window.HPN; if (!C || window.__hpnLoaded) return; window.__hpnLoaded = true;
  var D = document, W = window;
  var R = ((W.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var origFetch = W.fetch.bind(W);
  var drawer = D.querySelector('[data-hpn-drawer]');
  var page = D.querySelector('[data-hpn-page]');
  /* codes cachés gérés par le panier (ajoutés quand ils servent, retirés sinon) : un par cadeau (mode « code »), app, formules */
  var codeDe = function (g) { return g.code || C.codeGift || ''; };
  var HIDDEN = [C.codeApp, C.codeGift, C.codeF40, C.codeAn].concat((C.gifts || []).map(function (g) { return g.code; })).filter(Boolean).map(function (x) { return x.toUpperCase(); });
  var G = C.gifts || [];
  var flashMsg = '', lastFocus = null, modifie = false;

  /* ---------- outils ---------- */
  function rate() { var r = parseFloat(W.Shopify && Shopify.currency && Shopify.currency.rate); return r > 0 ? r : 1; }
  function cur() { return (W.Shopify && Shopify.currency && Shopify.currency.active) || C.cur || 'EUR'; }
  /* même écriture que le filtre money de Shopify (ex. « €24,90 ») : déduite de l'exemple 1234,56 rendu par Liquid */
  var MF = (function () { var m = String(C.moneySample || '').match(/^(.*?)1([^0-9]?)234(?:([^0-9])56)?(.*)$/); return m ? { pre: m[1], mil: m[2], dec: m[3], suf: m[4] } : null; })();
  function money(c) {
    c = Math.round(c);
    if (MF) { var ent = Math.floor(c / 100), cts = ('0' + (c % 100)).slice(-2); var e = String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, MF.mil); return MF.pre + e + (MF.dec ? MF.dec + cts : '') + MF.suf; }
    try { return new Intl.NumberFormat(D.documentElement.lang || 'fr', { style: 'currency', currency: cur() }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cur(); }
  }
  /* seuil d'un palier (centimes d'euro) dans la devise de la cliente */
  function sv(c) { return C.eur ? c : Math.round(c * 1.1 * rate()); }
  function rond(c) { return money(Math.ceil(c / 100) * 100).replace(/([,.])00(?=\D|$)/, ''); } /* « €40 » */
  var PAL = (C.paliers || []).slice().sort(function (a, b) { return a.c - b.c; });
  function rnd() { return Math.random().toString(36).slice(2, 8); }
  function hash(g) { return 'product-discount-' + g.kusd + '-percentage-100'; }
  function api(path, body) {
    return origFetch(R + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-HPN': '1' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'cart'); e.data = j; throw e; } return j; }); });
  }
  function getCart() { return api('cart.js'); }
  var props = function (it) { return it.properties || {}; };
  function isApp(it) { return props(it)._hv_cadeau === 'app30'; }
  function isF40(it) { return props(it)._hv_cadeau === 'formule40'; }
  /* coffret L'Archive (30/10/2026) : 2e formule (_hv_cadeau = formule-archive) et 1 an de Musliminera (_hv_cadeau = musliminera),
     offerts par la fonction « Cadeaux Qalbeen » tant que le panier a le coffret (carnet + 2 inserts payés, _archive = coffret)
     pendant l'offre de lancement ; sinon retirés ici (et par le garde-fou s'ils ne sont pas à 0 €) */
  var ARCHIVE_FIN = Date.parse('2026-11-08T23:59:59+01:00');
  function isArch(it) { var c = props(it)._hv_cadeau; return c === 'formule-archive' || c === 'musliminera'; }
  function coffretArchive(cart) {
    if (Date.now() > ARCHIVE_FIN) return false;
    var carnet = cart.items.some(function (it) { return it.handle === 'l-archive-carnet-organisateur' && props(it)._archive === 'coffret'; });
    var ins = cart.items.reduce(function (s, it) { return it.handle === 'l-archive-inserts' && props(it)._archive === 'coffret' ? s + it.quantity : s; }, 0);
    return carnet && ins >= 2;
  }
  function isGift(it) { var p = props(it); return !!(p._kaching_cart || (p._hv_cadeau && p._hv_cadeau !== 'app30')); }
  /* formule offerte avec Musliminera 1 an (31/10/2026, _hv_offre = formule-musliminera) : comme un cadeau, elle ne compte ni
     dans les paliers ni comme « formule payée » (pas de 30 jours de Qalbeen+ en cascade) */
  function isFmus(it) { return props(it)._hv_offre === 'formule-musliminera' && /^(formule-|la-formule-mariage-by-qalbeen$)/.test(it.handle || ''); }
  function compte(it) { return !isGift(it) && !isApp(it) && !isFmus(it) && C.exclus.indexOf(it.handle) < 0; }
  function physique(it) { return compte(it) && it.requires_shipping; }
  /* montant compté pour les paliers : tout le panier payé (sans cadeaux ni exclus) */
  function phys(cart) { return cart.items.reduce(function (s, it) { return compte(it) ? s + it.final_line_price : s; }, 0); }
  function nPhys(cart) { return cart.items.filter(physique).length; }
  /* montant compté par le code de la formule offerte : seulement les produits de ses collections (éditions, carnets, app…) */
  /* l'app 1 an est « consommée » par le code des formules offertes à l'année (codeAn) : elle ne compte plus pour ce code-ci */
  function anConsomme(it) { return !!C.codeAn && appProduit(it) && /-1-an/.test(it.handle || ''); }
  /* abonnements (app au mois, à l'année) exclus : un abonnement « consommé » par ce code perdrait sa propre réduction
     (constaté le 16/10/2026 : 30 jours de l'app redevenus payants) ; le code doit donc avoir isSubscription = false côté « achète » */
  function f40Base(cart) { var H = C.f40h || []; return cart.items.reduce(function (s, it) { return compte(it) && H.indexOf(it.handle) >= 0 && !anConsomme(it) && !it.selling_plan_allocation ? s + it.final_line_price : s; }, 0); }
  /* formules offertes avec l'app 1 an : offre des fiches (_hv_offre = formule-an) ou page de l'app (_hv_offre = app-an-2-formules) */
  function isFan(it) { var o = props(it)._hv_offre; return (o === 'formule-an' || o === 'app-an-2-formules') && /^(formule-|la-formule-mariage-by-qalbeen$)/.test(it.handle || ''); }
  function appAn(it) { return appProduit(it) && /-1-an/.test(it.handle || ''); }
  var NFAN = 2; /* formules offertes par le code codeAn */
  var PF = null; (C.paliers || []).forEach(function (p) { if (p.f && !PF) PF = p; }); /* palier de la formule offerte */
  /* formule offerte proposée d'office : selon le 1er produit physique payé du panier (mêmes choix que les fiches), sinon Sakina */
  var F40_DEF = {
    'cartes-habibi-edition-couple': 'formule-wasl', 'cartes-tafkir-illumines-tes-discussions': 'formule-wasl', 'cartes-qadar-edition-mouqabala': 'formule-wasl',
    'cartes-tafkids-edition-parent-enfant': 'formule-tarbiya', 'jeu-memo-les-25-prophetes-du-coran-50-cartes': 'formule-tarbiya', 'les-duaas-essentielles-stickers': 'formule-tarbiya',
    'carte-nafsi-edition-introspection-personnelle': 'formule-sakina', 'cartes-hikma-le-quizz-islam-qui-inspire-et-connecte': 'formule-nour',
    'cartes-nissa-le-quiz-des-plus-grandes-femmes-de-l-islam': 'formule-karama', 'le-pouvoir-du-voile-by-safaaetoi': 'formule-karama',
    'stickers-qalbeen-du-moment': 'formule-karama', 'cassette-souvenir-audio': 'formule-wasl',
    'l-archive-carnet-organisateur': 'formule-karama', 'l-archive-inserts': 'formule-karama'
  };
  function formuleParDefaut(cart) {
    var deja = cart.items.map(function (it) { return it.handle; });
    var it = cart.items.filter(function (x) { return compte(x) && x.requires_shipping && F40_DEF[x.handle] && deja.indexOf(F40_DEF[x.handle]) < 0; })[0];
    if (it) return F40_DEF[it.handle];
    return ['formule-sakina', 'formule-wasl', 'formule-karama', 'formule-nour'].filter(function (h) { return deja.indexOf(h) < 0; })[0] || 'formule-sakina';
  }
  function f40Permis(P, np) { return !!(PF && C.codeF40 && np > 0 && P >= sv(PF.c)); }
  function appProduit(it) { return !isApp(it) && /^app-qalbeen/.test(it.handle || ''); } /* l'app achetée (au mois, à l'année…) */
  function giftOfLine(it) {
    var p = props(it), h = null;
    if (p._kaching_cart) { try { h = JSON.parse(p._kaching_cart).promoHash; } catch (e) {} }
    for (var i = 0; i < G.length; i++) {
      var g = G[i]; if (g.variant !== it.variant_id) continue;
      if (g.mode === 'kaching' && h && h === hash(g)) return g;
      if (g.mode === 'code' && p._hv_cadeau === 'cadeau') return g;
    }
    return null;
  }

  /* cadeaux refusés par Shopify pour ce total (évite de les rajouter en boucle) ; app retirée par la cliente */
  var bloques = {};
  try { bloques = JSON.parse(sessionStorage.getItem('hpn-bloques') || '{}') || {}; } catch (e) {}
  function bloque(k, P) { return bloques[k] === P; }
  function bloquer(k, P) { bloques[k] = P; try { sessionStorage.setItem('hpn-bloques', JSON.stringify(bloques)); } catch (e) {} }
  function refusApp(v) { try { if (v === undefined) return sessionStorage.getItem('hpn-app-refus') === '1'; if (v) sessionStorage.setItem('hpn-app-refus', '1'); else sessionStorage.removeItem('hpn-app-refus'); } catch (e) { return false; } }

  /* ---------- file d'opérations ---------- */
  var chain = Promise.resolve(), busy = 0;
  function q(fn) {
    busy++; setBusy(true);
    chain = chain.then(fn).catch(function (e) { if (W.console) console.warn('[panier HOVER]', e); flash(C.t.error); return rendre().catch(function () {}); })
      .then(function () { busy--; if (!busy) setBusy(false); });
    return chain;
  }
  function setBusy(b) { [drawer, page].forEach(function (el) { if (el) el.classList.toggle('is-busy', b); }); }

  /* ---------- synchronisation des cadeaux ---------- */
  function plan(cart) {
    var P = phys(cart), np = nPhys(cart), out = { attrs: null, add: [], upd: {}, codes: null };
    var gardes = {};
    /* un cadeau : au moins un produit physique, le seuil de son palier, et (Kaching) le palier Kaching qui l'offre */
    var permis = function (g) { return np > 0 && P > 0 && P >= sv(g.min || 0) && (g.mode !== 'kaching' || (g.kusd > 0 && P >= g.kusd * 100 * rate())); };
    var arOk = coffretArchive(cart), arVus = {};
    cart.items.filter(isArch).forEach(function (it) {
      var c = props(it)._hv_cadeau;
      if (!arOk || arVus[c]) out.upd[it.key] = 0; else { arVus[c] = 1; if (it.quantity !== 1) out.upd[it.key] = 1; }
    });
    cart.items.filter(function (it) { return isGift(it) && !isF40(it) && !isArch(it); }).forEach(function (it) {
      var g = giftOfLine(it);
      var garde = g && permis(g) && !bloque('g' + g.n, P) && !gardes[g.n];
      if (!garde) out.upd[it.key] = 0; else { gardes[g.n] = 1; if (it.quantity !== 1) out.upd[it.key] = 1; }
    });
    G.forEach(function (g) {
      if (!permis(g) || gardes[g.n] || bloque('g' + g.n, P)) return;
      if (g.mode === 'code' && !codeDe(g)) return;
      if (g.mode === 'kaching' && !g.kusd) return;
      out.add.push({ id: g.variant, quantity: 1, properties: g.mode === 'kaching' ? { _kaching_cart: JSON.stringify({ promoHash: hash(g), promoRewardUniqueId: rnd() }) } : { _hv_cadeau: 'cadeau' } });
      gardes[g.n] = 1;
    });
    /* total PHYSIQUE transmis à la réduction Kaching Cart (même valeur que la jauge) */
    if (G.some(function (g) { return g.mode === 'kaching'; })) {
      var a = null; try { a = JSON.parse((cart.attributes || {})._kaching_cart_attributes || 'null'); } catch (e) {}
      if (!a || a.totalAfterDiscounts !== P || a.marketCurrencyCode !== cur()) out.attrs = { _kaching_cart_attributes: JSON.stringify({ totalAfterDiscounts: P, marketCurrencyCode: cur() }) };
    }
    /* app 30 jours : dès un produit physique ou une formule thérapie payée */
    var appAchetee = cart.items.some(appProduit);
    /* gardée avec un produit physique OU une formule payée (les quiz offrent aussi le 1er mois avec une formule) ;
       ajoutée d'office dans les deux cas (26/10/2026 ; avant : seulement avec un produit physique), la cliente peut la retirer */
    var nForm = cart.items.filter(function (it) { return compte(it) && /^(formule-|la-formule-mariage-by-qalbeen$)/.test(it.handle || ''); }).length;
    var appOk = !!C.app && (np > 0 || nForm > 0) && !bloque('app', P) && !appAchetee, apps = cart.items.filter(isApp);
    apps.forEach(function (it, i) { if (!appOk || i > 0) out.upd[it.key] = 0; else if (it.quantity !== 1) out.upd[it.key] = 1; });
    var appGarde = appOk && apps.length > 0;
    if (appOk && (np > 0 || nForm > 0) && !apps.length && C.app.pre && !refusApp()) {
      out.add.push({ id: C.app.variant, quantity: 1, selling_plan: C.app.plan, properties: { _hv_cadeau: 'app30' } });
      appGarde = true;
    }
    /* formule offerte : une seule, et seulement au-dessus de son palier */
    var PB = P, f40 = cart.items.filter(isF40), f40Ok = f40Permis(PB, np) && !bloque('f40', PB); /* même montant que les autres paliers (la fonction compte P) */
    f40.forEach(function (it, i) { if (!f40Ok || i > 0) out.upd[it.key] = 0; else if (it.quantity !== 1) out.upd[it.key] = 1; });
    /* 26/10/2026 (Wyssem) : la formule offerte est ajoutée D'OFFICE dès le palier (près d'une cliente éligible sur deux ne la
       choisissait pas), formule proposée selon le 1er produit physique du panier ; « Changer » sur sa ligne pour en prendre une autre */
    if (f40Ok && !f40.length) out.f40auto = formuleParDefaut(cart);
    /* formules offertes avec l'app 1 an : retirées si l'app 1 an n'est plus dans le panier (sinon elles deviendraient payantes),
       2 au plus (une unité chacune) */
    var anOk = !!C.codeAn && cart.items.some(appAn), nFan = 0;
    cart.items.filter(isFan).forEach(function (it) {
      if (!anOk) { out.upd[it.key] = 0; return; }
      var reste = NFAN - nFan; if (reste <= 0) { out.upd[it.key] = 0; return; }
      if (it.quantity > reste) out.upd[it.key] = reste;
      nFan += Math.min(it.quantity, reste);
    });
    /* formule offerte avec Musliminera : une par Musliminera 1 an payé, retirée sinon */
    var nMus = cart.items.reduce(function (t, it) { return it.handle === 'musliminera-1-an' && compte(it) ? t + it.quantity : t; }, 0), nFm = 0;
    cart.items.filter(isFmus).forEach(function (it) {
      var reste = nMus - nFm; if (reste <= 0) { out.upd[it.key] = 0; return; }
      if (it.quantity > reste) out.upd[it.key] = reste;
      nFm += Math.min(it.quantity, reste);
    });
    /* codes : ceux de la cliente + les codes cachés utiles, rien d'autre */
    var actuels = (cart.discount_codes || []).map(function (d) { return d.code; });
    var voulus = actuels.filter(function (c) { return HIDDEN.indexOf(c.toUpperCase()) < 0; });
    /* Depuis le 22/10/2026, les cadeaux sont rendus gratuits par la fonction de remise « Cadeaux Qalbeen » (app-com/,
       remise automatique) à partir des propriétés de ligne : AUCUN code caché n'est plus posé (ils fuyaient) ;
       ceux qui resteraient dans un panier ouvert avant la bascule sont retirés ci-dessus (filtre HIDDEN). */
    var norm = function (l) { return l.map(function (x) { return x.toUpperCase(); }).sort().join(','); };
    if (norm(voulus) !== norm(actuels)) out.codes = voulus;
    out.vide = !out.attrs && !out.add.length && !Object.keys(out.upd).length && !out.codes && !out.f40auto;
    return out;
  }
  function appliquer(p) {
    modifie = true;
    var s = Promise.resolve();
    if (p.attrs) s = s.then(function () { return api('cart/update.js', { attributes: p.attrs }); });
    if (p.add.length) s = s.then(function () {
      return api('cart/add.js', { items: p.add }).catch(function () {
        /* produit cadeau épuisé ou refusé : on n'insiste pas pour ce total */
        return getCart().then(function (c) { var P = phys(c); p.add.forEach(function (a) { if (a.properties && a.properties._hv_cadeau === 'app30') return bloquer('app', P); var g = G.filter(function (x) { return x.variant === a.id; })[0]; if (g) bloquer('g' + g.n, P); }); });
      });
    });
    var u = {}; if (Object.keys(p.upd).length) u.updates = p.upd; if (p.codes) u.discount = p.codes.join(',');
    if (u.updates || u.discount !== undefined) s = s.then(function () { return api('cart/update.js', u); });
    if (p.f40auto) s = s.then(function () {
      return origFetch(R + 'products/' + encodeURIComponent(p.f40auto) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('formule'); return r.json(); })
        .then(function (pr) { var v = (pr.variants || []).filter(function (x) { return x.available; })[0]; if (!v) throw new Error('formule');
          return api('cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { _hv_cadeau: 'formule40' } }] }); })
        .catch(function () { return getCart().then(function (c) { bloquer('f40', phys(c)); }); }); /* formule introuvable : on n'insiste pas pour ce total */
    });
    return s;
  }
  function synchro() {
    return getCart().then(function (cart) {
      if (!C.enabled) return cart;
      var pass = 0;
      function boucle(c) {
        var p = plan(c);
        if (p.vide || pass++ >= 3) return garde(c);
        return appliquer(p).then(getCart).then(boucle);
      }
      return boucle(cart);
    });
  }
  /* garde-fou : un cadeau payant n'est jamais laissé dans le panier */
  function garde(cart) {
    var P = phys(cart), upd = {}, appKo = false, fKo = false;
    cart.items.forEach(function (it) {
      if (isF40(it) && it.final_line_price > 0) { bloquer('f40', f40Base(cart)); upd[it.key] = 0; fKo = true; return; }
      if ((isFan(it) || isFmus(it)) && it.final_line_price > 0) { upd[it.key] = 0; fKo = true; return; }
      if (isGift(it) && it.final_line_price > 0) { var g = giftOfLine(it); bloquer(g ? 'g' + g.n : 'x', P); upd[it.key] = 0; }
      if (isApp(it) && it.final_line_price > 0) { bloquer('app', P); upd[it.key] = 0; appKo = true; }
    });
    if (!Object.keys(upd).length) return cart;
    modifie = true;
    if (appKo) flash(C.t.appKo); else if (fKo) flash(C.t.f40Ko);
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { var u = c.toUpperCase(); return !(appKo && u === (C.codeApp || '').toUpperCase()) && !(fKo && u === (C.codeF40 || '').toUpperCase()); });
    return api('cart/update.js', { updates: upd, discount: codes.join(',') }).then(getCart);
  }

  /* ---------- rendu ---------- */
  function rendre(cart) {
    var ids = [];
    if (drawer) ids.push('hover-cart-drawer');
    if (page) ids.push(page.getAttribute('data-section'));
    ids.push('cart-icon-bubble');
    return origFetch(R + 'cart?sections=' + ids.join(','), { credentials: 'same-origin', headers: { 'X-HPN': '1' } }).then(function (r) { return r.json(); }).then(function (j) {
      var parse = function (h) { return new DOMParser().parseFromString(h || '', 'text/html'); };
      if (drawer && j['hover-cart-drawer']) remplacer(drawer.querySelector('#HvCartBody'), parse(j['hover-cart-drawer']).querySelector('[data-hpn-body]'));
      if (page && j[page.getAttribute('data-section')]) remplacer(page, parse(j[page.getAttribute('data-section')]).querySelector('[data-hpn-page] [data-hpn-body]'));
      var ic = D.getElementById('cart-icon-bubble');
      if (ic && j['cart-icon-bubble']) { var s = parse(j['cart-icon-bubble']).querySelector('.shopify-section'); if (s) ic.innerHTML = s.innerHTML; }
      peindre();
      return (cart && cart.items ? Promise.resolve(cart) : getCart()).then(function (c) { noteJardin(c); return cart; });
    });
  }
  /* Solde Jardin Qalbeen (codes JARDIN<n>-XXXXXXXX, fonction « Jardin Qalbeen » de app-com/) : la remise ne s'applique que dès 40 €
     d'achat hors cadeaux et cartes cadeaux (même calcul que la fonction) ; tant que ce n'est pas le cas, on dit ce qui manque au
     lieu de laisser Shopify refuser le code sans explication (03/11/2026, « pas de vague de SAV »). */
  var JARDIN = /^JARDIN(\d{1,2})-[A-Z0-9]{8}$/i;
  function noteJardin(cart) {
    Array.prototype.forEach.call(D.querySelectorAll('[data-hpn-jardin]'), function (n) { n.remove(); });
    if (!cart || !cart.items) return;
    var d = (cart.discount_codes || []).filter(function (x) { return JARDIN.test(x.code); })[0];
    if (!d || d.applicable) return;
    var n = +JARDIN.exec(d.code)[1];
    var P = cart.items.reduce(function (s, it) {
      return compte(it) && !isFan(it) && props(it)._archive !== 'insert-offert' && !it.gift_card ? s + it.original_line_price : s;
    }, 0);
    var manque = sv(4000) - P;
    var txt = manque > 0
      ? '🌱 Tes <b>' + n + ' €</b> du Jardin Qalbeen s’appliquent dès 40 € d’achat : encore <b>' + money(manque) + '</b>.'
      : '🌱 Tes ' + n + ' € du Jardin Qalbeen ne se cumulent pas avec un autre code promo. Retire l’autre code pour les utiliser.';
    Array.prototype.forEach.call(D.querySelectorAll('[data-hpn-body] .hpn-foot'), function (f) {
      var p = D.createElement('p'); p.className = 'hpn-jardin'; p.setAttribute('data-hpn-jardin', ''); p.innerHTML = txt;
      f.insertBefore(p, f.firstChild);
    });
  }
  function remplacer(box, neuf) {
    if (!box || !neuf) return;
    /* les boutons de paiement express sont rangés hors du contenu remplacé, puis remis sous le bouton par peindre() */
    var ex = box.querySelector('[data-hpn-express]');
    if (ex) { ex.hidden = true; (box.closest('[data-hpn-drawer]') || box.closest('.hpn-pagewrap') || D.body).appendChild(ex); }
    var sc = box.querySelector('[data-hpn-scroll]'), y = sc ? sc.scrollTop : 0;
    var det = Array.prototype.map.call(box.querySelectorAll('details'), function (d) { return d.open; });
    box.innerHTML = ''; box.appendChild(neuf);
    var sc2 = box.querySelector('[data-hpn-scroll]'); if (sc2) sc2.scrollTop = y;
    Array.prototype.forEach.call(box.querySelectorAll('details'), function (d, i) { if (det[i]) d.open = true; });
  }
  function texte(tpl, montant, cadeau) { return (tpl || '').replace('[montant]', '<b>' + montant + '</b>').replace('[cadeau]', cadeau || ''); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* état des paliers pour un montant compté P et np produits physiques (même calcul partout) */
  function etat(P, np) {
    var N = PAL.length, faits = 0, pos = 0, suivant = null, iSuiv = -1, part = 0;
    PAL.forEach(function (pl, i) {
      var t = sv(pl.c), ok = np > 0 && P >= t;
      if (ok) { faits = i + 1; return; }
      if (!suivant) {
        suivant = pl; iSuiv = i;
        var t0 = i > 0 ? sv(PAL[i - 1].c) : 0;
        part = np > 0 && t > t0 ? Math.max(0, Math.min(1, (P - t0) / (t - t0))) : 0;
        /* repères au centre de chaque colonne : palier i atteint = (i + ½) / N */
        pos = np > 0 && i > 0 && t > t0 ? (i - 0.5 + part) / N : 0;
      }
    });
    if (!suivant) pos = 1;
    var gap = suivant && np > 0 ? Math.max(1, Math.ceil(sv(suivant.c) - P)) : 0;
    return { N: N, faits: faits, pos: pos, part: part, suivant: suivant, i: iSuiv, gap: gap, P: P, np: np };
  }
  function message(e) {
    if (!e.suivant) return esc(C.t.done);
    if (e.np === 0) return esc(C.t.zero || '');
    return texte(esc(C.t.next), money(e.gap), '<b>' + esc(e.suivant.t) + '</b>');
  }
  /* barre fine sous l'en-tête + échelle de l'accueil : lisent l'état du panier du tiroir */
  function peindreAilleurs(P, np, n) {
    var e = etat(P, np);
    D.querySelectorAll('[data-hpn-strip]').forEach(function (s) {
      var off = !np || !n || !PAL.length;
      s.classList.toggle('is-on', !off);
      s.setAttribute('aria-hidden', String(off));
      if (off) return;
      var nx = e.suivant ? sv(e.suivant.c) : 0, prev = e.i > 0 ? sv(PAL[e.i - 1].c) : 0;
      var w = !e.suivant ? 1 : Math.max(0.04, Math.min(1, (P - prev) / Math.max(1, nx - prev)));
      var f = s.querySelector('[data-hpn-strip-fill]'); if (f) f.style.transform = 'scaleX(' + w.toFixed(3) + ')';
      var m = s.querySelector('[data-hpn-strip-msg]'); if (m) m.innerHTML = message(e);
      s.classList.toggle('is-done', !e.suivant);
    });
    D.querySelectorAll('[data-hpn-ladder]').forEach(function (l) {
      l.classList.toggle('has-cart', np > 0);
      l.style.setProperty('--hpn-pos', np > 0 ? e.pos.toFixed(3) : 0);
      l.querySelectorAll('[data-hpn-rung]').forEach(function (li) {
        var i = +li.getAttribute('data-hpn-rung');
        li.classList.toggle('ok', np > 0 && i < e.faits);
        li.classList.toggle('next', np > 0 && i === e.i);
      });
      var m = l.querySelector('[data-hpn-ladder-msg]');
      if (m) { m.hidden = !(np > 0); if (np > 0) m.innerHTML = message(e); }
      var t0 = l.querySelector('[data-hpn-ladder-total]'); if (t0) { t0.hidden = !(np > 0); var b = t0.querySelector('b'); if (b) b.textContent = money(P); }
    });
  }
  function peindre() {
    var vide = true, ref = null;
    D.querySelectorAll('[data-hpn-body]').forEach(function (body) {
      var P = +body.getAttribute('data-phys') || 0, n = +body.getAttribute('data-count') || 0, np = +body.getAttribute('data-nphys') || 0, PB = +body.getAttribute('data-pf40') || 0;
      if (n > 0) vide = false;
      if (!ref) ref = { P: P, np: np, n: n };
      var e = etat(P, np), N = e.N, faits = e.faits, pos = e.pos, suivant = e.suivant, gap = e.gap;
      body._hpnGap = gap; body._hpnNext = suivant;
      var bar = body.querySelector('[data-hpn-bar]');
      if (bar) {
        if (!N) bar.hidden = true;
        var fill = bar.querySelector('[data-hpn-fill]'); if (fill) fill.style.width = (pos * 100).toFixed(1) + '%';
        bar.querySelectorAll('[data-hpn-step]').forEach(function (li) {
          var i = +li.getAttribute('data-hpn-step'), pl = PAL[i]; if (!pl) return;
          li.classList.toggle('ok', i < faits);
          var am = li.querySelector('[data-hpn-amt]'); if (am && pl.c > 0) am.textContent = rond(sv(pl.c));
        });
        var msg = bar.querySelector('[data-hpn-msg]');
        if (msg) { msg.innerHTML = message(e); bar.classList.toggle('is-done', !suivant); }
      }
      /* formule offerte : débloquée au palier « formule » */
      var fc = body.querySelector('[data-hpn-f40]');
      if (fc) {
        var fok = !!PF && np > 0 && PB >= sv(PF.c) && !bloque('f40', PB); /* le code manquant est signalé au choix (choisirFormule) */
        fc.classList.toggle('is-locked', !fok);
        fc.hidden = !(np > 0) || !PF;
        var fl = fc.querySelector('[data-hpn-f40-locked]'); if (fl && PF) fl.innerHTML = esc(C.t.f40Locked || '').replace('[montant]', '<b>' + rond(sv(PF.c)) + '</b>');
      }
      /* carte de l'app : dès un produit physique ou une formule */
      var app = body.querySelector('[data-hpn-app]');
      if (app) {
        var appOk = (np > 0 || (+body.getAttribute('data-nform') || 0) > 0) && !bloque('app', P);
        app.classList.toggle('is-locked', !appOk);
        var bt = app.querySelector('[data-hpn-app-add]'); if (bt) bt.disabled = !appOk;
      }
      /* suggestions : 2, en priorité celle qui fait passer le palier */
      var box = body.querySelector('[data-hpn-ups]');
      if (box) {
        var cards = Array.prototype.slice.call(box.querySelectorAll('[data-hpn-up]'));
        var tri = cards.map(function (el, i) { var pr = +el.getAttribute('data-price'); return { el: el, i: i, pr: pr, passe: gap > 0 && pr >= gap }; });
        if (gap > 0) tri.sort(function (a, b) { if (a.passe !== b.passe) return a.passe ? -1 : 1; return a.passe ? a.pr - b.pr : b.pr - a.pr; });
        tri.forEach(function (o, k) {
          o.el.hidden = k >= 2; box.appendChild(o.el);
          var h = o.el.querySelector('[data-hpn-up-hint]'); if (h) { h.hidden = !o.passe; if (o.passe) h.textContent = (C.t.unlock || '').replace('[cadeau]', (suivant && suivant.t) || C.short || C.label); }
        });
      }
      /* paiement express : déplacé sous le bouton */
      var slot = body.querySelector('[data-hpn-express-slot]'), root = body.closest('[data-hpn-drawer]') || body.closest('.hpn-pagewrap');
      var ex = root && root.querySelector('[data-hpn-express]');
      if (slot && ex) { slot.appendChild(ex); ex.hidden = false; }
      var f = body.querySelector('[data-hpn-flash]'); if (f) { f.hidden = !flashMsg; f.textContent = flashMsg; }
    });
    if (drawer) drawer.classList.toggle('is-empty', vide);
    /* la barre fine et l'échelle suivent le panier du tiroir (ou de la page panier) */
    var dB = drawer && drawer.querySelector('[data-hpn-body]');
    if (dB) ref = { P: +dB.getAttribute('data-phys') || 0, np: +dB.getAttribute('data-nphys') || 0, n: +dB.getAttribute('data-count') || 0 };
    if (ref) peindreAilleurs(ref.P, ref.np, ref.n);
  }
  function flash(m) { flashMsg = m || ''; clearTimeout(flash.t); if (m) flash.t = setTimeout(function () { flashMsg = ''; D.querySelectorAll('[data-hpn-flash]').forEach(function (f) { f.hidden = true; }); }, 7000); }

  /* ---------- ouverture ---------- */
  var surPagePanier = !!page;
  function ouvrir() {
    if (!drawer || surPagePanier) return;
    lastFocus = lastFocus || D.activeElement;
    var panel = drawer.querySelector('.hpn-panel');
    drawer.classList.add('on'); D.documentElement.classList.add('hpn-lock');
    panel.setAttribute('aria-hidden', 'false');
    setTimeout(function () { var x = drawer.querySelector('[data-hpn-close].hpn-x') || panel; x.focus({ preventScroll: true }); }, 60);
  }
  function fermer() {
    if (!drawer || !drawer.classList.contains('on')) return;
    drawer.classList.remove('on'); D.documentElement.classList.remove('hpn-lock');
    drawer.querySelector('.hpn-panel').setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    lastFocus = null;
  }
  var tPlan = null, tOpen = false;
  function planifier(open) {
    if (open) { tOpen = true; ouvrir(); }
    clearTimeout(tPlan);
    tPlan = setTimeout(function () { tOpen = false; q(function () { return synchro().then(rendre); }); }, 120);
  }

  /* Compatible avec les formulaires de Dawn (product-form.js, quick-add) : ils cherchent <cart-drawer> */
  if (drawer && !customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      getSectionsToRender() { return [{ id: 'hover-cart-drawer', selector: '#HvCartBody' }, { id: 'cart-icon-bubble' }]; }
      renderContents() { this.classList.remove('is-empty'); planifier(true); }
      setActiveElement(el) { lastFocus = el; }
      open() { ouvrir(); }
      close() { fermer(); }
    });
  }

  /* Tout ajout au panier fait ailleurs (Kaching Bundles, scripts des sections…) : on resynchronise et on ouvre */
  var reCart = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  W.fetch = function (input, init) {
    var p = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var h = init && init.headers, mine = h && (h['X-HPN'] || (typeof h.get === 'function' && h.get('X-HPN')));
      var meth = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (!mine && meth === 'POST' && reCart.test(url)) {
        var add = /\/cart\/add/.test(url);
        p.then(function (r) { if (r.ok) planifier(add); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__hvc = (String(m).toUpperCase() === 'POST' && reCart.test(String(u))) ? (/\/cart\/add/.test(String(u)) ? 'add' : 'chg') : null; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { var x = this; if (x.__hvc) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) planifier(x.__hvc === 'add'); }); return xs.apply(this, arguments); };

  /* ---------- actions ---------- */
  function majQte(key, n) { return q(function () { return api('cart/change.js', { id: key, quantity: n }).then(synchro).then(rendre); }); }
  function ajouter(items) { return q(function () { return api('cart/add.js', { items: items }).then(synchro).then(rendre); }); }
  function codes(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }
  function appliquerCode(code) {
    return q(function () {
      return getCart().then(function (c) {
        var act = codes(c); if (act.some(function (x) { return x.toUpperCase() === code.toUpperCase(); })) return;
        return api('cart/update.js', { discount: act.concat(code).join(',') }).then(function (c2) {
          var d = (c2.discount_codes || []).filter(function (x) { return x.code.toUpperCase() === code.toUpperCase(); })[0];
          if (d && !d.applicable && JARDIN.test(code)) { flash(''); return; } /* solde Jardin : gardé, noteJardin dit ce qui manque */
          if (!d || !d.applicable) { flash(C.t.codeKo); return api('cart/update.js', { discount: act.join(',') }); }
          flash('');
        });
      }).then(synchro).then(rendre);
    });
  }
  /* formule offerte : remplace la formule déjà choisie, puis le code caché est posé par synchro() */
  function choisirFormule(id, type) {
    type = type === 'formule-archive' ? type : 'formule40';
    if (type === 'formule40' && !C.codeF40) { flash(C.t.f40Ko); return q(rendre); }
    return q(function () {
      return getCart().then(function (c) {
        var u = {}; c.items.forEach(function (it) { if (props(it)._hv_cadeau === type) u[it.key] = 0; });
        return (Object.keys(u).length ? api('cart/update.js', { updates: u }) : Promise.resolve())
          .then(function () { return api('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _hv_cadeau: type } }] }); });
      }).then(synchro).then(rendre);
    });
  }
  function retirerCode(code) {
    return q(function () {
      return getCart().then(function (c) {
        return api('cart/update.js', { discount: codes(c).filter(function (x) { return x.toUpperCase() !== code.toUpperCase(); }).join(',') });
      }).then(synchro).then(rendre);
    });
  }

  D.addEventListener('click', function (e) {
    var t = e.target;
    var ic = t.closest('#cart-icon-bubble, [data-hpn-open]');
    if (ic && drawer && !surPagePanier) { e.preventDefault(); ouvrir(); planifier(false); return; }
    if (!t.closest('[data-hpn-drawer], [data-hpn-page]')) return;
    if (t.closest('[data-hpn-close]')) { e.preventDefault(); fermer(); return; }
    var b = t.closest('[data-hpn-qty]'); if (b && !b.disabled) { e.preventDefault(); if (b.closest('.hpn-line--app') && b.getAttribute('data-q') === '0') refusApp(true); b.closest('[data-hpn-line]') && b.closest('[data-hpn-line]').classList.add('is-busy'); majQte(b.getAttribute('data-hpn-qty'), +b.getAttribute('data-q')); return; }
    var a = t.closest('[data-hpn-add]'); if (a) { e.preventDefault(); a.classList.add('is-busy'); ajouter([{ id: +a.getAttribute('data-hpn-add'), quantity: 1 }]); return; }
    var ap = t.closest('[data-hpn-app-add]'); if (ap && !ap.disabled) { e.preventDefault(); ap.classList.add('is-busy'); refusApp(false); ajouter([{ id: +ap.getAttribute('data-hpn-app-add'), quantity: 1, selling_plan: +ap.getAttribute('data-plan'), properties: { _hv_cadeau: 'app30' } }]); return; }
    var fo = t.closest('[data-hpn-f40-open]');
    if (fo) {
      e.preventDefault();
      var box = fo.closest('[data-hpn-f40]'), libre = fo.hasAttribute('data-libre') || (box && !box.classList.contains('is-locked'));
      var cur = fo.getAttribute('data-current') || '';
      var typ = fo.getAttribute('data-type') || 'formule40';
      if (W.HVFormules) HVFormules.open({ mode: libre ? 'choisir' : 'voir', current: cur, onPick: function (f) { if (f && f.id) choisirFormule(f.id, typ); } });
      return;
    }
    var cr = t.closest('[data-hpn-code-rm]'); if (cr) { e.preventDefault(); retirerCode(cr.getAttribute('data-hpn-code-rm')); return; }
    var go = t.closest('[data-hpn-checkout]');
    if (go) {
      e.preventDefault(); go.classList.add('is-busy');
      chain.then(function () { W.location.href = '/checkout'; });
    }
  });
  D.addEventListener('change', function (e) {
    var t = e.target;
    var ad = t.closest && t.closest('[data-hpn-addon]');
    if (ad) {
      var id = +ad.getAttribute('data-hpn-addon');
      if (ad.checked) ajouter([{ id: id, quantity: 1 }]);
      else q(function () { return getCart().then(function (c) { var u = {}; c.items.forEach(function (it) { if (it.variant_id === id && !isGift(it)) u[it.key] = 0; }); return api('cart/update.js', { updates: u }); }).then(synchro).then(rendre); });
    }
  });
  D.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-hpn-code-form]'); if (!f) return;
    e.preventDefault(); var v = (f.code.value || '').trim(); if (v) appliquerCode(v);
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });

  /* ---------- démarrage ---------- */
  peindre();
  if (C.enabled) {
    /* panier déjà rempli (retour sur le site, autre onglet) : remet les cadeaux en ordre sans ouvrir */
    var n0 = 0; D.querySelectorAll('[data-hpn-body]').forEach(function (b) { n0 = Math.max(n0, +b.getAttribute('data-count') || 0); });
    if (n0 > 0) q(function () { modifie = false; return synchro().then(function (c) { if (modifie) return rendre(c); noteJardin(c); return c; }); });
  }
  /* retour arrière (bfcache) : le panier a pu changer ailleurs */
  W.addEventListener('pageshow', function (e) { if (e.persisted) q(function () { return synchro().then(rendre); }); });
  W.HVCart = { open: ouvrir, close: fermer, refresh: function (o) { planifier(!!o); } };
})();
